<template>
    <b-row no-gutters> <!-- style="float:right;size:100%"> -->
        <div class="col-sm-10 d-flex flex-column">

          <vl-map :load-tiles-while-animating="true" :load-tiles-while-interacting="true"
                       data-projection="EPSG:4326" style="height: 90vh" ref="map">
          <vl-view :zoom.sync="zoom" :center.sync="center" :rotation.sync="rotation"></vl-view>
            <vl-layer-tile id="osm">
              <vl-source-bing-maps :api-key="apiKey" :imagery-set="imagerySet"></vl-source-bing-maps>
            </vl-layer-tile>

            <div v-for="jota in filteredJotas" :key="jota.id">
              <vl-overlay :position="[jota.position.lng, jota.position.lat]"
                   :positioning="'bottom-center'" :stop-event="false" >
                <template slot-scope="scope">
                  <div class="overlay-content">
                    <div class="map-icon-text">{{ jota.id }}</div>
                    <img class="jota-icon" v-if="jota.status == 0" v-on:click="clickedJota(jota.id, $event)" src='../assets/map/icons/free.png'>
                    <img class="jota-icon" v-if="jota.status == 1" v-on:click="clickedJota(jota.id, $event)" src='../assets/map/icons/loaded.png'>
                  </div>
                </template>
              </vl-overlay>
            </div>
            <div v-for="point in points" :key="point.date">
              <vl-overlay :position="[point.position.lng, point.position.lat]"
                   :positioning="'bottom-center'" :stop-event="false" >
                <template slot-scope="scope">
                  <div class="overlay-content">
                    <img class="point-icon" v-if="point.rssi < -119" src='../assets/map/icons/point1.png'>
                    <img class="point-icon" v-if="point.rssi >= -119 && point.rssi < -115" src='../assets/map/icons/point2.png'>
                    <img class="point-icon" v-if="point.rssi >= -115 && point.rssi < -110" src='../assets/map/icons/point3.png'>
                    <img class="point-icon" v-if="point.rssi >= -110 && point.rssi < -108" src='../assets/map/icons/point4.png'>
                    <img class="point-icon" v-if="point.rssi >= -108 && point.rssi < -100" src='../assets/map/icons/point5.png'>
                    <img class="point-icon" v-if="point.rssi >= -100 && point.rssi < -90" src='../assets/map/icons/point6.png'>
                    <img class="point-icon" v-if="point.rssi >= -90 && point.rssi < -70" src='../assets/map/icons/point7.png'>
                    <img class="point-icon" v-if="point.rssi >= -70" src='../assets/map/icons/point8.png'>
                  </div>
                </template>
              </vl-overlay>
            </div>
          </vl-map>
        </div>
        <div class="col-sm-2 flex-column" style="float:right">
          <div class="sidemenu-group">
            <div class="sidmenu-title">{{ $t("components.map.options.titleShow") }}</div>
            <div class="sidemenu-element">
              <b-form-checkbox-group id="show-hide-button-group" style="padding-left:20px">
                <b-button :pressed.sync="showElements.freeJotas" variant="primary">{{ $t("components.map.options.freeJotas") }}</b-button>
                <b-button :pressed.sync="showElements.loadedJotas" variant="primary">{{ $t("components.map.options.loadedJotas") }}</b-button>
                <b-button :pressed.sync="showElements.lincopys" variant="primary">{{ $t("components.map.options.lincopys") }}</b-button>
              </b-form-checkbox-group>
            </div>
          </div>
          <div class="sidemenu-group flex-grow-1">
            <div class="sidmenu-title">{{ $t("components.map.options.titleSelectedJota") }}</div>
            <div class="sidemenu-element">
              <b-form inline @submit="onSubmit">
                <b-form-group id="selectedJotaIdLabel">
                  <b-form-input id="selectedJotaId"
                                required
                                disabled
                                v-model="jotaSelected.id"
                                placeholder="Selecciona una jota"
                                size="sm">
                  </b-form-input>
                </b-form-group>
                <b-form-group>
                  <b-button id="button-jota-status" :disabled="jotaSelected.id == undefined" :pressed.sync="jotaSelectedStatus" variant="primary">
                    <template v-if="jotaSelectedStatus">
                      {{ $t("components.map.options.free") }}
                    </template>
                    <template v-else>
                      {{ $t("components.map.options.loaded") }}
                    </template>
                  </b-button>
                </b-form-group>
                <div>
                  <b-button style="float:right" v-on:click="saveJotaState" :disabled="jotaSelected.id == undefined" type="submit" variant="primary">Actualizar</b-button>
                </div>
              </b-form>
            </div>
          </div>
          <div class="sidemenu-group flex-grow-1">
            <div class="sidmenu-title">{{ $t("components.map.options.titleJotas") }}</div>
            <div class="sidemenu-element vertical-scroll-list">
              <b-table striped hover small responsive style="font-weight:bold"
              :items="filteredTableJotas"
              :fields="tableFields"
               @row-clicked="rowClickHandler">
                <template slot="status" slot-scope="data">
                      {{ data.value }}
                </template>
              </b-table>
            </div>
          </div>

          <div class="sidemenu-group flex-grow-1">
            <div class="sidmenu-title">{{ $t("components.map.options.titleAdd") }}</div>
            <div class="sidemenu-element vertical-scroll-list">
              <form>
                <div class="form-group">
                  <strong>ID</strong><br>
                  <input v-model="id" placeholder="ID del dispositivo"><br>
                  <strong>Descripción</strong><br>
                  <textarea v-model="description" placeholder="Descripción"></textarea><br>
                  <strong>Tipo</strong><br>
                  <select v-model="type">
                    <option v-for="option in options" v-bind:value="option.value" :key="option.value">
                      {{ option.text }}
                    </option>
                  </select>
                  <br><b-button v-on:click="postData" style="float:right;" variant="primary">Añadir</b-button>
                </div>
              </form>
            </div>
          </div>

        </div>

        <modal name="dialog"
          transition="nice-modal-fade"
          :min-width="100"
          :min-height="100"
          :width="300"
          :height="400"
          :delay="100"
          :resizable="true"
          :draggable="true">
          <div class="popup" style="text-align:center;padding:8px">
            <h3 v-if="jotaSelected.id != undefined">{{jotaSelected.id}}</h3>
            <b>longitud:</b><p v-if="jotaSelected.position != undefined">{{jotaSelected.position.lng}}</p>
            <b>latitud:</b><p v-if="jotaSelected.position != undefined">{{jotaSelected.position.lat}}</p>
            <b>estado:</b><p v-if="jotaSelected.status == 1">Cargada</p><p v-if="jotaSelected.status == 0">Libre</p>
            <b>descripción:</b><p v-if="jotaSelected.description != undefined">{{jotaSelected.description}}</p>
            <b>última actualización:</b><p v-if="jotaSelected.lastUpdate != undefined">{{jotaSelected.lastUpdate}}</p>
          </div>
        </modal>


        <b-modal ref="markerModal" centered title="TagWan detailed INFO" ok-only>
          <table class="table table-striped">

          </table>
        </b-modal>
    </b-row>
</template>

<script>
import Service from './Service'

export default {
  name: 'Map',
  data () {
    return {
      apiKey: "Aj_iTOwX8qzqWox9yvatNVmhV1IuVoEBc1oUAKHexTfA6gT50FDTdNjD5We3paUH",
      imagerySet: "AerialWithLabels",
      zoom: 18,
      showElements: {
        freeJotas: true,
        loadedJotas: true,
        lincopys: true,
      },
      jotas: [],
      options: [
        { text: 'Jota', value: '0' },
        { text: 'Lincopy', value: '1' }
      ],
      id: 0,
      description: "",
      type: 0,
      tableJotas: [],
      tableFields: [{'key':'id'}, {'key': 'status_loc', label: 'Estado'}],
      lincopys: [],
      center: [-8.226300, 43.47860],
      rotation: 0,
      geolocPosition: undefined,
      isAutoCenter: true,
      jotaSelected: {},
      jotaClicked: {},
      jotaSelectedStatus: false,
      jotaSelectedStatusText: 'Estado',
      points: [],
      personid: "",
    }
  },
  created () {
    document.title = 'TagWAN - 5Js'
  },
  mounted: function () {
    this.personid = Math.random().toString(36).substring(7);
    Service.getTrakables(this.getJotas);
    //Service.getPoints(this.getPoints);
    this.$options.sockets.onmessage = function(data) {
        var msg = JSON.parse(data.data);
        console.log(msg.latitude);
        console.log(msg.longitude);
      //  console.log(msg.altitude);
        console.log(msg.id);

        this.jotas.forEach((jota) => {
        //  console.log(jota.id);
          if (jota.id == msg.id) {
            //jota.status = msg.status;
            (jota.status == 1) ? jota.status = 0 : jota.status = 1;// just make it change color every message to notice that a message arrived
            if (Math.abs(msg.longitude) > 0.001 && msg.type == 136) {
              jota.position.lng = msg.longitude;
              jota.position.lat = msg.latitude;
            }
          }
        });
    };
    var v = this;
    setInterval(function () {
      v.getGPSPosition();
    }, 1000);
  },
  methods: {
    postData: function() {
      this.ajaxRequest = true;
      console.log(this.id);
      console.log(this.description);
      console.log(this.type);
      if (!this.isAlready(this.id))
      {
        this.$http.post('https://5jotas.4m1g0.com:1880/data', {
          id: this.id,
          description: this.description,
          type: this.type
        },
        function (data, status, request) {
          this.postResults = data;
          console.log(request)
          this.ajaxRequest = false;
        });
        var jota = {"id": this.id, "status": 0};
        jota.status_loc = "Libre";
        jota._cellVariants = {"status_loc": "success"};
        jota.position = {};
        jota.description = this.description;
        jota.type = this.type;
        jota.position.lng = 0;
        jota.position.lat = 0;
        this.jotas.push(jota);
        this.tableJotas.push(jota);
      }
    },
    isAlready(id) {
      var is = false;
      this.jotas.forEach((jota) => {
        if (jota.id == id)
          is = true;
      });
      return is;
    },
    show () {
      this.$modal.show('dialog');
    },
    hide () {
      this.$modal.hide('dialog');
    },
    // eslint-disable-next-line
    clickedJota (jotaId, event){
    //  console.log(jotaId);
      this.show();
      this.selectedJota(jotaId);
      this.saveJotaState();
    },
    selectedJota(jotaId) {
      this.jotas.forEach((jota) => {
        if (jota.id == jotaId) {
            this.jotaSelected = jota;
            if(jota.status == "free"){
              this.jotaSelectedStatus = true;
            } else {
              this.jotaSelectedStatus = false;
            }
        }
      });
    },
    toggleChanged(checked){
      console.log(checked);
    },
    onSubmit(event) {
      event.preventDefault();
    },
    getJotas (jotas) {
      this.jotas = jotas;
      this.jotasToTable();
    },
    getPoints (points) {
      console.log(points);
      this.points = points;
    },
    getLincopys () {
      return [ {
        "id": "lincopy01",
        "position": {"lat": 30.5420384, "lng": -6.279511},
        "lastUpdate": "2018-08-13T14:20:02+00:00"
      },
      {
        "id": "lincopy02",
        "position": {"lat": 30.5120384, "lng": -6.277511},
        "lastUpdate": "2018-08-13T14:20:02+00:00"
      }

      ];
    },
    jotasToTable () {
      this.tableJotas = [];
      this.jotas.forEach((element) => {
        console.log(element);
        var jota = {"id": element.id, "status": element.status};
        if(element.status == 1){
          jota.status_loc = "Cargada";
          jota._cellVariants = {"status_loc": "danger"};
        } else if (element.status == 0){
          jota.status_loc = "Libre";
          jota._cellVariants = {"status_loc": "success"};
        }
        this.tableJotas.push(jota);
      });
    },
    // eslint-disable-next-line
    rowClickHandler (item, index, event) {
      this.jotas.forEach((jota) => {
        if(jota.id == item.id) {
          this.selectedJota(jota.id);
          this.center = [jota.position.lng, jota.position.lat];
          //this.jotaSelected = jota.id ;
        }
      });
    },
    saveJotaState(){
      console.log(this.jotaSelected);
      this.jotaSelected.status = (this.jotaSelectedStatus === true) ? 0 : 1;
      this.jotasToTable();
    },
    getGPSPosition() {		
      if(navigator.geolocation){
        navigator.geolocation.getCurrentPosition(this.showPosition);
      }else{
        this.error = "Geolocation is not supported."; 
      }
    },
    showPosition(position) {	
      console.log(position.coords.latitude,position.coords.longitude);
      this.$http.post('https://nodered.armriot.com/personpos', {
          id: this.personid,
          lat: position.coords.latitude,
          lng: position.coords.longitude
        },
        function (data, status, request) {
          console.log(request)
          this.ajaxRequest = false;
        });
    }
  },
  watch: {
    filteredTableJotas () {
      this.$nextTick(() => {
        //this.center = [-6.277511, 36.5320584];
      });
    }
  },
  computed: {
    filteredTableJotas () {
      return this.tableJotas.filter((jota) => {
            if (this.showElements.freeJotas && this.showElements.loadedJotas) {
              return true;
            } else if (this.showElements.freeJotas) {
              return jota.status == 0;
            } else if (this.showElements.loadedJotas) {
              return jota.status == 1;
            } else {
              return false;
            }
          });
    },
    filteredJotas () {
      return this.jotas.filter((jota) => {
            if (this.showElements.freeJotas && this.showElements.loadedJotas) {
              return true;
            } else if (this.showElements.freeJotas) {
              return jota.status == 0;
            } else if (this.showElements.loadedJotas) {
              return jota.status == 1;
            } else {
              return false;
            }
          });
    }
  }
}
</script>

<style scoped>
#map {
  height: 100vh;
  width: 100%;
}

popup {
  padding: 10px;
  text-align: center;
}

#map-options {
  width: 100%;
  padding: 5px;
}

#show-hide-button-group {
  width: 100%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 1px;
  max-height: 80vh;
  background-color: rgba(0, 0, 0, 0.1);
}

.vertical-scroll-list {
  max-height: calc(100vh - 520px);
  overflow-y: auto;
}
#show-hide-button-group > .btn-warning:not(.active) {
  background-color: rgba(0, 0, 0, 0.3);
  /*background-color: rgba(255, 193, 7, 0.3);*/
}

#show-hide-button-group > .btn-success:not(.active) {
  background-color: rgba(0, 0, 0, 0.3);
  /*background-color: rgba(30, 126, 52, 0.3);*/
}

#show-hide-button-group > .btn-danger:not(.active) {
  background-color: rgba(0, 0, 0, 0.3);
  /*background-color: rgba(220, 53, 69, 0.3);*/
}

#button-jota-status {
  width: 100%;
}

#button-jota-status:not(.active) {
  background-color: rgba(191, 0, 12, 1);
  box-shadow: rgba(0, 0, 0, 0);
  border: 0px;
}

#button-jota-status:not(.disabled).active {
  background-color: rgba(0, 191, 4, 1);
  box-shadow: rgba(0, 0, 0, 0);
  border: 0px;
 }

#button-jota-submit {
  width: 100%;
}

.sidemenu-element {
  padding: 5px;
}

.sidemenu-group {
  background-color: rgba(0, 51, 102, 0.7);
  display: flex;
  flex-direction: column;
  align-items: left;
}

.sidmenu-title {
  font-size: 1.1rem;
  color: white;
  border-bottom: 1px solid #AAAAAA;
  border-top: 1px solid #AAAAAA;
  background-color: rgba(0, 51, 102, 1);
  text-align: center;
}

.overlay-content{
  display: flex;
  flex-direction: column;
  align-items: center;
}

.jota-icon {
  width : 64px;

}

.point-icon {
  width : 34px;
}

.map-icon-text {
    text-align:center;
    background-color: rgba(255, 255, 255, 0.7);
    margin-bottom: 5px;
}

.menu-container {
  background-color: #FFF;
  border: 1px solid  rgba(0, 0, 0, 0.5);
}

.menu-title {
  text-align: center;
  font-size: 1.5em;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.1);
}

.sub-menu-title {
  text-align: center;
  font-size: 1.2em;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.2);
}

.filter-body {
  padding: 5px;
}

.filter-title {
  padding: 5px;
  font-size: 1.05em;
  width: 100%;
  background-color: rgba(79, 163, 252, 0.7);
}

.wide-button{
  width: 100%;
}

.col-sm-10 {
  height: 100%;
}

.map-truck-icon-label{
  width: 50px;
  height: 20px;
  border: 1px solid #eb3a44;
  border-radius: 5px;
  background: #fee1d7;
  text-align: center;
  line-height: 20px;
  font-weight: bold;
  font-size: 14px;
  color: #eb3a44;
}

.table-striped>tbody>tr:nth-child(odd){
    background-color:#003366;
    color: #ffffff;
}

.table-striped>tbody>tr:nth-child(even){
    background-color:#FFFFFF;
}

.marker-label{
 background-color: #FFFFFF;
}
</style>
